export type LoaderSize = 'lg' | 'sm' | 'md' | 'xs';

export enum LoaderSizeEnum {
  LG = 'lg',
  SM = 'sm',
  MD = 'md',
  XS = 'xs'
}